import { Form, Input, Select, Switch, TimePicker } from "antd";
import dayjs from "dayjs";

const DAY_OPTIONS = [
	{ value: 1, label: "Dushanba" },
	{ value: 2, label: "Seshanba" },
	{ value: 3, label: "Chorshanba" },
	{ value: 4, label: "Payshanba" },
	{ value: 5, label: "Juma" },
	{ value: 6, label: "Shanba" },
	{ value: 7, label: "Yakshanba" },
];

export function StaffWorkdayForm() {
	return (
		<>
			<Form.Item
				name="staffId"
				label="Xodim ID"
				rules={[
					{ required: true, message: "Xodim ID kiriting" },
					{
						message: "To'g'ri UUID formatini kiriting",
					},
				]}
			>
				<Input placeholder="550e8400-e29b-41d4-a716-446655440000" />
			</Form.Item>

			<Form.Item
				name="dayNumber"
				label="Kun"
				rules={[{ required: true, message: "Kunni tanlang" }]}
			>
				<Select placeholder="Kunni tanlang" options={DAY_OPTIONS} />
			</Form.Item>

			<Form.Item
				name="start"
				label="Boshlanish vaqti"
				rules={[{ required: true, message: "Boshlanish vaqtini kiriting" }]}
				getValueFromEvent={(time) => (time ? dayjs(time).format("HH:mm:ss") : "")}
				getValueProps={(value) => ({ value: value ? dayjs(value, "HH:mm:ss") : undefined })}
			>
				<TimePicker format="HH:mm:ss" style={{ width: "100%" }} placeholder="09:00:00" />
			</Form.Item>

			<Form.Item
				name="end"
				label="Tugash vaqti"
				rules={[{ required: true, message: "Tugash vaqtini kiriting" }]}
				getValueFromEvent={(time) => (time ? dayjs(time).format("HH:mm:ss") : "")}
				getValueProps={(value) => ({ value: value ? dayjs(value, "HH:mm:ss") : undefined })}
			>
				<TimePicker format="HH:mm:ss" style={{ width: "100%" }} placeholder="18:00:00" />
			</Form.Item>

			<Form.Item name="isWorkday" label="Ish kuni" valuePropName="checked">
				<Switch checkedChildren="Ha" unCheckedChildren="Yo'q" defaultChecked />
			</Form.Item>
		</>
	);
}
